export default [
    {
        id: "310473440000_3159100724",
        name: "Booking.com B.V.",
        domain: "booking.com"
    },
    {
        id: "528349800000_141686352",
        name: "Frankwatching B.V.",
        domain: "frankwatching.com",
    },
    {
        id: "321495130000_199259920",
        name: "Emerce B.V.",
        domain: "emerce.nl"
    },
    {
        id: "559956080000_210471924",
        name: "Adyen International B.V.",
        domain: "adyen.com",
    },
    {
        id: "859159710000_3927613810",
        name: "Mollie International B.V.",
        domain: "mollie.com"
    }
];
